import { clsx } from 'clsx';
import type { ElementType, ReactNode } from 'react';

import { Surface, type SurfaceProps } from '@storebrand-digital/pretzel';

export type RoundedPaddedSurfaceProps<As extends ElementType = 'div'> =
  SurfaceProps<As> & {
    className?: string;
    children?: ReactNode;
  };

/**
 * A pretzel `Surface` with the standard bank rounding and padding applied.
 */
export function RoundedPaddedSurface<As extends ElementType = 'div'>({
  className,
  ...rest
}: RoundedPaddedSurfaceProps<As>) {
  return (
    <Surface
      {...rest}
      className={clsx(className, 'px-16 lg:px-20 py-20 lg:py-24 rounded-small')}
    />
  );
}
